import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    Button,
    CircularProgress,
    FormControlLabel,
    Grid,
    Stack,
    Switch,
    useTheme,
} from "@mui/material";
import { toast } from "react-toastify";
import Header from "../../components/Header";
import { CssTextField } from "../../components/TextField";
import { tokens } from "../../theme";
import {
    getMobileAppVersionConfig,
    updateMobileAppVersionConfig,
} from "../../store/actions";

const MobileAppVersion = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { isLoading } = useSelector(({ loading }) => ({ isLoading: loading }));

    const [currentVersion, setCurrentVersion] = useState("");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [updateMessage, setUpdateMessage] = useState("");

    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = async () => {
        let data = await dispatch(getMobileAppVersionConfig());
        if (data) {
            setCurrentVersion(data.current_version || "");
            setForceUpdate(data.force_update || false);
            setUpdateMessage(data.update_message || "");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!currentVersion.trim()) {
            return toast.error("Please enter the app version");
        }

        let res = await dispatch(
            updateMobileAppVersionConfig({
                currentVersion: currentVersion.trim(),
                forceUpdate,
                updateMessage: updateMessage.trim(),
            })
        );

        if (res) {
            toast.success("Mobile app version config updated");
        }
    };

    return (
        <Box m="20px" mb={15}>
            <Header
                title="MOBILE APP VERSION"
                subtitle="Manage mobile app version and force update settings"
            />

            <Box
                width="100%"
                p={3}
                borderRadius={2}
                backgroundColor={colors.primary[400]}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={3}>
                                <CssTextField
                                    fullWidth
                                    required
                                    label="Current App Version"
                                    placeholder="e.g. 2.4.1"
                                    value={currentVersion}
                                    onChange={(e) => setCurrentVersion(e.target.value)}
                                />

                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={forceUpdate}
                                            onChange={(e) => setForceUpdate(e.target.checked)}
                                            color="success"
                                        />
                                    }
                                    label="Force Update"
                                />

                                <CssTextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Update Message"
                                    placeholder="Please update the app to continue using the service."
                                    value={updateMessage}
                                    onChange={(e) => setUpdateMessage(e.target.value)}
                                />

                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={isLoading}
                                    sx={{ width: "fit-content" }}
                                >
                                    {isLoading ? (
                                        <CircularProgress color="inherit" size={24} />
                                    ) : (
                                        <b>Save</b>
                                    )}
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    );
};

export default MobileAppVersion;
